import { render, staticRenderFns } from "./EstadoDeudaShowData.vue?vue&type=template&id=59cdf4b0"
import script from "./EstadoDeudaShowData.vue?vue&type=script&lang=js"
export * from "./EstadoDeudaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports